export const getStatusColor = (status) => {
    const map = {
        gagal: 'red',
        invalid: 'red',
        failed: 'red',
        dibatalkan: 'red',
        pending: 'yellow',
        success: 'green',
    };

    return map[status?.toLowerCase()] || 'gray';
};
